module.exports = __webpack_public_path__ + "img/icon_L4.305a44fb.png";